<template>
  <a :class="`tab ${active ? 'active' : ''}`" @click.prevent="emit($event)" :href="link">
    <i :class="`icon-${icon}`" v-if="icon" />
    <template v-if="title">
      <div class="label">{{ title }}</div>
    </template>
    <template v-else>
      <div class="label">
        <slot />
      </div>
    </template>
  </a>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    tabIndex: {
      type: Number,
      default: 0,
    },
    link: {
      type: String,
      default: '',
    },
  },
  methods: {
    /**
     * Emit click event to parent
     * @param {Object} event
     */
    emit(event) {
      if (this.disabled) {
        return;
      }

      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab {
  border-right: 1px solid #EEF0F9;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  // padding: 7px 12px 3px;
  padding: 4px;
  height: 52px;
  white-space: nowrap;

  &.red {
    &, &.active {
      background-color: var(--color-live);
      .label {
        color: white;
      }
    }
  }

  i {
    color: #0060FF;
    font-size: 24px;
    transition: all .3s;
  }

  .label {
    color: #0060FF;
    font-size: 10px;
    font-weight: 500;
    text-align: center;
    transition: all .3s;
    line-height: 18px;
    display: flex;
    align-items: center;
  }

  &:last-child {
    border-right: none;
  }

  &.active {
    background-color: #F0F2F5;

    .label, i {
      color: black;
    }
  }

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 768px) {
    flex-direction: row;
    padding-left: 20px;
    padding-right: 20px;

    .label {
      font-size: 13px;
    }

    i {
      font-size: 20px;
      margin-right: 8px;
    }

    &:first-child {
      border-left: 1px solid #EEF0F9;
    }

    &:last-child {
      border-right: 1px solid #EEF0F9;
    }
  }

  @media (min-width: 1024px) {
    // padding-left: 25px;
    // padding-right: 25px;

    i {
      font-size: 22px;
      margin-right: 10px;
    }

    .label {
      font-size: 15px;
    }
  }

  @media (min-width: 1280px) {
    // padding-left: 30px;
    // padding-right: 30px;

    i {
      font-size: 24px;
    }

    .label {
      font-size: 16px;
    }
  }
}
</style>
